import React from 'react';
import FormItemEditorControl from './FormItemEditorControl';
import FormItemDateEditor from '../FormItemDateEditor';
import FormItemDateEditorForDataGrid from '../FormItemDateEditorForDataGrid';
import FormItemDateRender from '../renders/FormItemDateRender';
import FormItemUtil from '../../utils/FormItemUtil';
import EditorFormType from '../../utils/EditorFormType';
import ControlPropertyConst from '../controlproperty/ControlPropertyConst';
import FormItemDateDisplay from '../display/FormItemDateDisplay';

export default class FormItemDateEditorControl extends FormItemEditorControl
{
	constructor(menuItemId,formId,parent,xml,group,module,forLookup) {
		super(menuItemId,formId,parent,xml,group,module,forLookup);
		this.classAlias = "FormItemDateEditorControl";
	}

	validateNotNull()
	{
		var _dataField = this.getDataField();
		if(_dataField && this.group && this.group.currentRecord)
		{
			var value = this.group.currentRecord[_dataField];
			if(!value || value == "" || value == 0)
			{
				var _label = this.getProperty_Label();
				return _label+" 不能为空";
			}
		}
		return null;
	}

	getSelfNotNull()
	{
		var key = this.formId+this.xml.id+ControlPropertyConst.NOTNULL;
		var notnull = window.controlProperties[key];
		if(notnull)
			return notnull;
		var notnull = this.xml.Properties.NotNull.Value;
		if(typeof(notnull) == "string")
		{
			return notnull == "true"?true:false;
		}
		else
		{
			return notnull;
		}
		//return this.xml.Properties.NotNull.Value;
	}

	/*getProperty_DisplayFormat()
	{
		return this.properties.DisplayStyle;
	}*/
	
	getDefaultDisplayLength()
	{
		return 12;
	}

	getProperty_Seperator()
	{
		return "-";
		return this.properties.Seperator;
	}
	getProperty_NumOfYear()
	{
		if(this.properties.hasOwnProperty("NumOfYear"))
			return this.properties.NumOfYear;
		return FormItemDateDisplay.defaultNumOfYear;
	}
	getProperty_NumOfDay()
	{
		if(this.properties.hasOwnProperty("NumOfDay"))
			return this.properties.NumOfDay;
		return FormItemDateDisplay.defaultNumOfDay;
	}
	getProperty_NumOfMonth()
	{
		if(this.properties.hasOwnProperty("NumOfMonth"))
			return this.properties.NumOfMonth;
		return FormItemDateDisplay.defaultNumOfMonth;
	}
	getProperty_Show1970()
	{
		return true;
		return this.properties.Show1970;
	}

	getProperty_DisplayFormat()
	{
		let _displayStyle = this.getProperty_DisplayStyle();
		//let _displayStyle = {"fontFamily":"微软雅黑","buttonStyle":"普通","VerticalAlignment":"Center","fontSize":"72","fontStyle":"","HorizontalAlignment":"Center","fontWeight":"bold"};
		if(_displayStyle && _displayStyle.DisplayFormat)
			return _displayStyle.DisplayFormat.toUpperCase();
		return "";
	}

	getQueryFilteredVaue(value)
	{
		var filter = this.getProperty_QueryFilter();
		if(!value)return "";
		if(filter == ">+dateNull")
		{
			return ">"+value+",''";
		}
		else if(filter == ">=+dateNull")
		{
			return ">="+value+",''";
		}
		else if(filter == "<+dateNull")
		{
			return "<"+value;
		}
		else if(filter == "<=+dateNull")
		{
			return "<="+value;
		}
		else if(filter == "<")
		{
			return "<"+value+"&<>''";
		}
		else if(filter == "<=")
		{
			return "<="+value+"&<>''";
		}
		else
		{
			return super.getQueryFilteredVaue(value);
		}
	}

	getComponentInstance(parent,forLookup)
	{
		let layout = parent.Properties.Layout.Value;
		let displayLengthWidth = this.getDisplayLengthWidth();
		let label = this._cmdLabel?this._cmdLabel:this.getProperty_Label();
		let commonProps = this.getCommonProps();
		let displayLength=this.propertyDisplayLength?this.propertyDisplayLength:this.getProperty_DisplayLength();
		let displayHeight=this.getProperty_DisplayHeight();
		let notNull=this.propertyNotNull?this.propertyNotNull:this.getProperty_NotNull();
		let _initRecord = this.record;
		if(!_initRecord)
		{
		  	if(!this.group)
		  	{
		  		let defaultValue = this.getDefaultValue();
		  		_initRecord = defaultValue;
		  	}
		}
		let displayStyle = this.getProperty_DisplayStyle();
		
        this.component = <FormItemDateEditor displayLengthWidth={displayLengthWidth} 
        		displayLength={displayLength} displayHeight={displayHeight}  notNull={notNull} moduleInstanceId={this.module.instanceUUId}
                  key={this.xml.id} xml={this.xml} formType={EditorFormType.FormModule} 
                  parentLayout={layout} forLookup={forLookup} groupAlias={this.groupAlias}
                  dataField = {this.getDataField()} initRecord = {_initRecord} initEditorValue={this.initEditorValue}
                  label={label} customStyle={this.getStyle()} formId={this.formId} menuItemId={this.menuItemId} contextMenuData={this.contextMenuData}
                  contextMenuData={this.contextMenuData} seperator={this.getProperty_Seperator()} numOfYear={this.getProperty_NumOfYear()}
                  numOfDay={this.getProperty_NumOfDay()} numOfMonth={this.getProperty_NumOfMonth()} show1970={this.getProperty_Show1970()}
				  control={this} underQueryGroup={this.isUnderQueryGroup()} verticalAlign={this.getProperty_VAlignment()}
				  cssStyle={this.getProperty_CSSStyle_Display()} displayStyle={displayStyle} {...commonProps}/>;
		return this.component;
	}

	getComponentInstanceForDataGrid(parent,forLookup)
	{
		return <FormItemDateEditorForDataGrid key={this.xml.id} xml={this.xml} forLookup={forLookup} group={this.group} formType={EditorFormType.FormModule} control={this}
				groupAlias={this.groupAlias} moduleInstanceId={this.module.instanceUUId} formId={this.formId} menuItemId={this.menuItemId} colXml={this.xml} gridXml={this.parentXML}
				verticalAlign={this.getProperty_VAlignment()}/>;
	}

	getRenderForDataGrid(forLookup)
	{
		let displayStyle = this.getProperty_DisplayStyle();
		let displayFormat = this.getProperty_DisplayFormat();
		return <FormItemDateRender contextMenuData={this.contextMenuData} group={this.group} dataField = {this.getDataField()} numOfDay={this.getProperty_NumOfDay()} numOfMonth={this.getProperty_NumOfMonth()} show1970={this.getProperty_Show1970()}
				numOfYear={this.getProperty_NumOfYear()} seperator={this.getProperty_Seperator()} formId={this.formId} menuItemId={this.menuItemId} colXml={this.xml} gridXml={this.parentXML} textAlign={this.getProperty_Alignment()} forLookup={forLookup} moduleInstanceId={this.module.instanceUUId}
				verticalAlign={this.getProperty_VAlignment()} displayFormat={displayFormat} cssStyle={this.getProperty_CSSStyle_Display()}
				displayStyle={displayStyle}/>;
	}

	getRenderForDynamicColumn(dataField)
	{
		let displayStyle = this.getProperty_DisplayStyle();
		let displayFormat = this.getProperty_DisplayFormat();
		return <FormItemDateRender contextMenuData={this.contextMenuData} group={this.group} dataField = {dataField} numOfDay={this.getProperty_NumOfDay()} numOfMonth={this.getProperty_NumOfMonth()} show1970={this.getProperty_Show1970()}
				numOfYear={this.getProperty_NumOfYear()} seperator={this.getProperty_Seperator()} formId={this.formId} menuItemId={this.menuItemId} colXml={this.xml} gridXml={this.parentXML} textAlign={this.getProperty_Alignment()} forLookup={forLookup} moduleInstanceId={this.module.instanceUUId}
				verticalAlign={this.getProperty_VAlignment()} displayFormat={displayFormat} cssStyle={this.getProperty_CSSStyle_Display()} displayStyle={displayStyle}/>;
	}
}


// WEBPACK FOOTER //
// ./src/formItem/controls/FormItemDateEditorControl.js